import { render, staticRenderFns } from "./Comprobar.vue?vue&type=template&id=0280dc9c&"
import script from "./Comprobar.vue?vue&type=script&lang=js&"
export * from "./Comprobar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports